import localeConfigs from '@/config/locale';
import {LANGUAGE} from '@/constant/language';
import {getLocalData} from '@/lib/base/localData';

const mapping = {
  // 繁體中文
  zh: LANGUAGE.ZH_TW,
  'zh-hant': LANGUAGE.ZH_TW,
  'zh-tw': LANGUAGE.ZH_TW,
  'zh-hk': LANGUAGE.ZH_TW,
  'zh-mo': LANGUAGE.ZH_TW,

  // 簡體
  'zh-hans': LANGUAGE.ZH_CN,
  'zh-cn': LANGUAGE.ZH_CN,
  'zh-sg': LANGUAGE.ZH_CN,
  'zh-my': LANGUAGE.ZH_CN,

  // 日文
  ja: LANGUAGE.JA_JP,
  'ja-jp': LANGUAGE.JA_JP,

  // 其他
  default: LANGUAGE.EN_US,
};

/**
 * 取得預設的語言
 * @param {Array} supportLocaleList 支援的語言列表
 * @returns {String} 語言預設值
 */
const getDefaultLanguage = (
  supportLocaleList = localeConfigs.map(({code}) => code)
) => {
  const localData = getLocalData('locale');
  if (localData && supportLocaleList?.includes(localData)) {
    return localData;
  }

  // 取得瀏覽器語系
  const userLanguages = navigator.languages || [navigator.language];
  let result = null;

  for (const userLanguage of userLanguages) {
    if (userLanguage.includes('en')) {
      result = mapping.default;
      break;
    }
    const language = mapping[userLanguage.toLowerCase()];
    if (language && supportLocaleList?.includes(language)) {
      result = language;
      break;
    }
  }

  if (!result) result = mapping.default;
  return result;
};

export default getDefaultLanguage;
export {mapping, getDefaultLanguage};
